module.exports = __webpack_public_path__ + "static/img/male-1.65dcff59.png";